// ======================FAQ's Icons==========================================
import { ChevronRightIcon } from "@heroicons/react/24/solid";

import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import FlayoutFilterLink from "./flayoutFilterLink";

const ProjectAccordion = ({ title, projects, isOpen, onClick }) => {
  // console.log("ProjectAccordion", isOpen);
  const [sortProjets, setSortProjects] = useState(projects);
  const [years, setYears] = useState();

  const handleYears = (_, index) => {
    const newYears = [...years];
    newYears[index].checked = !newYears[index].checked;
    setYears(newYears);
    const includedYears = years
      .filter((year) => year.checked)
      .map((year) => year.item);

    console.log("Include Year", includedYears);

    const filteredProjects = projects.filter((project) =>
      includedYears.includes(project.year),
    );
    setSortProjects((prev) => filteredProjects);
  };

  const uniqueYears = (arrayOfObjects) => {
    let uniqueArray = [];
    let yearSet = new Set();
    arrayOfObjects.forEach((item) => {
      if (!yearSet.has(item.year)) {
        uniqueArray.push({
          item: item.year,
          checked: true,
        });
        yearSet.add(item.year);
      }
    });
    return uniqueArray;
  };

  useEffect(() => {
    setYears(uniqueYears(projects));
  }, []);

  return (
    <>
      <button
        onClick={onClick}
        className="flex w-full items-center justify-between gap-3 p-5"
      >
        <p className="text-start text-base font-normal text-visBlue">{title}</p>
        <motion.div
          initial={false}
          animate={{ rotate: isOpen ? 90 : 0 }}
          transition={{ duration: 0.3 }}
        >
          <ChevronRightIcon
            className={`${isOpen && "text-visRed"} size-5 font-thin text-visBlue`}
          />
        </motion.div>
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, marginTop: "0rem" }}
            animate={{ height: "auto", marginTop: "0.4rem" }}
            exit={{ height: 0, marginTop: "0rem" }}
            transition={{ duration: 0.3, ease: "linear" }}
            className="overflow-x-auto bg-white px-[5vw]"
          >
            <table className="my-20 w-full border-b border-visOrange">
              <tr className="bg-visOrange text-white">
                <th className="py-4">
                  <div className="w-full border-r border-slate-50 p-2">
                    Sr. No.
                  </div>
                </th>
                <th className="py-4">
                  <div className="w-full border-r border-slate-50 p-2">
                    Project
                  </div>
                </th>
                <th className="py-4">
                  <div className="w-full border-r border-slate-50 p-2 hover:cursor-pointer">
                    <FlayoutFilterLink handleYears={handleYears} years={years}>
                      Year
                    </FlayoutFilterLink>
                  </div>
                </th>
                <th className="py-4">
                  <div className="w-full border-r border-slate-50 p-2">
                    Duration
                  </div>
                </th>
                <th className="py-4">
                  <div className="w-full p-2">Project Area</div>
                </th>
              </tr>
              {sortProjets?.map((item, index) => {
                return (
                  <tr
                    key={index}
                    className="text-center font-extralight odd:bg-slate-100 even:border even:border-visOrange"
                  >
                    <td className="w-fit py-4">
                      <div className="border-r border-slate-300 p-2">
                        {index + 1}.
                      </div>
                    </td>
                    <td className="w-fit py-4">
                      <div className="border-r border-slate-300 p-2">
                        {item.project}
                      </div>
                    </td>
                    <td className="w-fit py-4">
                      <div className="border-r border-slate-300 p-2">
                        {item.year}
                      </div>
                    </td>
                    <td className="w-fit py-4">
                      <div className="border-r border-slate-300 p-2">
                        {item.duration}
                      </div>
                    </td>
                    <td className="w-fit py-4">
                      <div className="p-2">{item.projectArea}</div>
                    </td>
                  </tr>
                );
              })}
            </table>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default ProjectAccordion;
